import { useMemo } from "react";
import { type FieldValues, type Path } from "react-hook-form";
import { generateFieldName } from "@/components/site-builder/modules/CustomFormModule/utils/generateFieldName";
import { getFormFields } from "@/components/site-builder/modules/CustomFormModule/utils/getFormFields";
import { FormBuilderFieldInputType } from "@/constants/form-builder";
import { type FormBuilderFormEntity } from "@/types/form-builder";

export interface UseCustomFormDefaultValuesProps {
  formEntity: FormBuilderFormEntity;
}

export function useCustomFormDefaultValues(
  props: UseCustomFormDefaultValuesProps,
) {
  const { formEntity } = props;

  return useMemo(() => {
    const defaultValues: Record<Path<FieldValues>, unknown> = {};
    const fields = getFormFields(formEntity);

    fields.forEach((field) => {
      const fieldKey = generateFieldName(field);

      switch (field.inputType) {
        case FormBuilderFieldInputType.Checkbox: {
          defaultValues[fieldKey] = [];
          break;
        }
        case FormBuilderFieldInputType.SingleCheckbox: {
          defaultValues[fieldKey] = false;
          break;
        }
        default: {
          defaultValues[fieldKey] = "";
          break;
        }
      }
    });

    return defaultValues;
  }, [formEntity]);
}
